import React from "react";
import { DatePicker, Space } from "antd";
import moment, { Moment } from "moment";

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  onRangeChange: (startDate: string, endDate: string) => void;
  rangePresets?: { [key: string]: [Moment, Moment] };
  style?: React.CSSProperties;
  placeholder?: [string, string];
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onRangeChange,
  rangePresets,
  style,
  placeholder,
}) => {
  const handleRangeChange = (dates, dateStrings) => {
    if (dates) {
      onRangeChange(dateStrings[0], dateStrings[1]);
    } else {
      onRangeChange("", "");
    }
  };

  return (
    <Space direction="vertical" size={12}>
      <RangePicker
        value={
          startDate && endDate ? [moment(startDate), moment(endDate)] : null
        }
        onChange={handleRangeChange}
        format="YYYY-MM-DD"
        ranges={rangePresets}
        style={style}
        placeholder={placeholder}
      />
    </Space>
  );
};

export default DateRangePicker;
